import React from 'react'

const Currency = () => {
  return (
    <div>Currency</div>
  )
}

export default Currency